import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { DistribuicaoLimitesRoutingModule } from "./distribuicao-limites-routing.module";
import { DistribuicaoLimitesComponent } from "./distribuicao-limites/distribuicao-limites.component";
import { DistribuicaoLimitesConfiguracaoComponent } from './distribuicao-limites-configuracao/distribuicao-limites-configuracao.component';


@NgModule({
  imports: [ SharedModule,
            BrowserModule,
            CommonModule,
            HttpClientModule,
            DistribuicaoLimitesRoutingModule],
  exports: [],
  declarations: [ DistribuicaoLimitesComponent,
                
                ],
  providers: [],
  schemas: []
})
export class DistribuicaoLimitesModule { }
